// ReserveSuperAdmin.js
import React, { useState, useEffect } from 'react';
import '../../styles/ReserveSuperAdmin.css';
import '../../styles/EspaceBenevoles.css';

function ReserveSuperAdmin({ token, droit }) {
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    nom_utilisateur: '',
    mot_de_passe: '',
    droit: 'user',
    cle: 'Non',
  });
  const [newUserData, setNewUserData] = useState({
    nom_utilisateur: '',
    mot_de_passe: '',
    droit: 'user',
    cle: 'Non',
  });

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    fetchUtilisateurs();
  }, []);

  const fetchUtilisateurs = async () => {
    try {
      const response = await fetch(`${API_URL}/api/utilisateurs`, {
        headers: { Authorization: token },
      });
      const data = await response.json();
      setUtilisateurs(data);
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await fetch(`${API_URL}/api/utilisateurs/${id}`, {
        method: 'DELETE',
        headers: { Authorization: token },
      });
      fetchUtilisateurs();
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user.id);
    setFormData({
      nom_utilisateur: user.nom_utilisateur,
      mot_de_passe: '',
      droit: user.droit,
      cle: user.cle,
    });
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/utilisateurs/${editingUser}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error('Erreur lors de la modification');
      setEditingUser(null);
      setFormData({ nom_utilisateur: '', mot_de_passe: '', droit: 'user', cle: 'Non' });
      fetchUtilisateurs();
    } catch (error) {
      console.error('Erreur lors de la modification:', error);
      alert('Erreur lors de la modification');
    }
  };

  // Creation Utilisateur
  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(newUserData),
      });
      if (!response.ok) throw new Error('Erreur lors de la création');
      setNewUserData({ nom_utilisateur: '', mot_de_passe: '', droit: 'user', cle: 'Non' });
      fetchUtilisateurs();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la création');
    }
  };

  // Import XLSX
  const handleImportXLSX = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formDataFile = new FormData();
    formDataFile.append('file', file);

    try {
      const response = await fetch(`${API_URL}/api/planning/import-xlsx`, {
        method: 'POST',
        headers: { Authorization: token },
        body: formDataFile,
      });
      if (!response.ok) throw new Error('Erreur lors de l\'import');
      alert('Fichier XLSX importé avec succès.');
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'import du fichier XLSX.');
    }
  };

  // Export XLSX
  const handleExportXLSX = async () => {
    try {
      const response = await fetch(`${API_URL}/api/planning/export-xlsx`, {
        headers: { Authorization: token },
      });
      if (!response.ok) throw new Error('Erreur lors de l\'export');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'planning_export.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'export XLSX.');
    }
  };

  // Vidage de la table Planning
  const handleClearPlanning = async () => {
    if (!window.confirm('Êtes-vous sûr de vouloir vider la table planning ?')) return;

    try {
      const response = await fetch(`${API_URL}/api/clear`, {
        method: 'DELETE',
        headers: { Authorization: token },
      });
      if (!response.ok) throw new Error('Erreur lors de la suppression');
      alert('Table planning vidée avec succès.');
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur client lors de la suppression des données.');
    }
  };

  return (
    <div className="container-benevoles">
      
      {(droit === 'sadmin') && (
        <div>
          <h2>Gestion des Utilisateurs</h2>
        </div>
      )}
      {(droit === 'sadmin') && (
        <div className="admin-actions-benevoles">
          <h2>Gestion Table Planning</h2>
          <input
            type="file"
            id="import-xlsx"
            style={{ display: 'none' }}
            onChange={handleImportXLSX}
            accept=".xlsx,.xls"
          />
          <button 
            onClick={() => document.getElementById('import-xlsx').click()}
            className="button-benevoles">
            Importer XLSX
          </button>
          <button 
            onClick={handleExportXLSX}
            className="button-benevoles">
            Exporter XLSX
          </button>
          <button 
            onClick={handleClearPlanning}
            className="button-benevoles button-danger-benevoles">
            Vider Planning
          </button>
        </div>
      )}      

      <h2>Liste des Utilisateurs</h2>
      <div className="table-container-benevoles">
        <table className="table-benevoles">
          <thead>
            <tr>
              <th>Nom d'utilisateur</th>
              <th>Mot de passe</th>
              <th>Droit</th>
              <th>Clé</th>
              <th className="actions-cell-benevoles">Actions</th>
            </tr>
          </thead>
          <tbody>
            {utilisateurs.map((user) => (
              <tr key={user.id}>
                {editingUser === user.id ? (
                  <>
                    <td>
                      <input
                        type="text"
                        value={formData.nom_utilisateur}
                        onChange={(e) => setFormData({ ...formData, nom_utilisateur: e.target.value })}
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="password"
                        value={formData.mot_de_passe}
                        onChange={(e) => setFormData({ ...formData, mot_de_passe: e.target.value })}
                        placeholder="Nouveau mdp"
                      />
                    </td>
                    <td>
                      <select
                        value={formData.droit}
                        onChange={(e) => setFormData({ ...formData, droit: e.target.value })}
                      >
                        <option value="user">User</option>
                        <option value="admin">Admin</option>
                        <option value="sadmin">Super Admin</option>
                        <option value="muser">User restreint</option>
                      </select>
                    </td>
                    <td>
                      <select
                        value={formData.cle}
                        onChange={(e) => setFormData({ ...formData, cle: e.target.value })}
                      >
                        <option value="Oui">Oui</option>
                        <option value="Non">Non</option>
                      </select>
                    </td>
                    <td className="actions-cell-benevoles">
                      <button onClick={handleSubmitEdit} className="button-benevoles button-secondary-benevoles">
                        Enregistrer
                      </button>
                      <button onClick={() => setEditingUser(null)} className="button-benevoles button-danger-benevoles">
                        Annuler
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td>{user.nom_utilisateur}</td>
                    <td>••••••</td>
                    <td>{user.droit}</td>
                    <td>{user.cle}</td>
                    <td className="actions-cell-benevoles">
                      <button onClick={() => handleEdit(user)} className="button-benevoles button-secondary-benevoles">
                        Modifier
                      </button>
                      <button onClick={() => handleDelete(user.id)} className="button-benevoles button-danger-benevoles">
                        Supprimer
                      </button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
          {droit === 'sadmin' && (
            <tfoot className="tfoot-sticky-benevoles">
              <tr className="add-row-benevoles">
                <td>
                  <input
                    type="text"
                    placeholder="Nom d'utilisateur"
                    value={newUserData.nom_utilisateur}
                    onChange={(e) => setNewUserData({ ...newUserData, nom_utilisateur: e.target.value })}
                    required
                  />
                </td>
                <td>
                  <input
                    type="password"
                    placeholder="Mot de passe"
                    value={newUserData.mot_de_passe}
                    onChange={(e) => setNewUserData({ ...newUserData, mot_de_passe: e.target.value })}
                    required
                  />
                </td>
                <td>
                  <select
                    value={newUserData.droit}
                    onChange={(e) => setNewUserData({ ...newUserData, droit: e.target.value })}
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                    <option value="sadmin">Super Admin</option>
                    <option value="muser">User restreint</option>
                  </select>
                </td>
                <td>
                  <select
                    value={newUserData.cle}
                    onChange={(e) => setNewUserData({ ...newUserData, cle: e.target.value })}
                  >
                    <option value="Oui">Oui</option>
                    <option value="Non">Non</option>
                  </select>
                </td>
                <td className="actions-cell-benevoles">
                  <button onClick={handleCreateSubmit} className="button-benevoles button-success-benevoles">
                    Ajouter
                  </button>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}

export default ReserveSuperAdmin;
